
export interface Namespace{
  prefix:string
  namespace:string
}

export class Namespace{
  constructor(public prefix:string,public  namespace:string) {
    }
}

export interface SparqlResult {
  head: SparqlHeader;
  results: SparqlBindings;
}

export interface SparqlHeader {
  vars: string[];
}

export interface SparqlBindings {
  bindings: SparqlBinding[];
} 
 
export interface SparqlBinding {
  [name: string] : SparqlVariable
}

export class SparqlVariable {
  public id:string = ''
  public label:string = ''
  prefixId:string = ''
  language:String = 'en'
  type:string = ''
  value:string = ''
  xmlLang:string = ''
  datatype:string = ''
  constructor (binding:any = null) {
    if (binding) {
      if (binding.type) this.type = binding.type
      if (binding.value) this.value = binding.value
      if (binding["xml:lang"]) this.xmlLang = binding["xml:lang"]
      if (binding.datatype) this.datatype = binding.datatype
    }
  }

  clone () {
    var result = new SparqlVariable();
      if (this.label) result.label = this.label
      if (this.type) result.type = this.type
      if (this.value) result.value = this.value
      if (this.xmlLang) result.xmlLang = this.xmlLang
      if (this.datatype) result.datatype = this.datatype
    return result  
  }  
}


export interface RdfProxy{
  query:string
  method:string
}
//interface for more variables in state
export interface TreeNode {
  label:string,
  url:string,
  prefixId:string,
  icon:string,
  children:TreeNode[],
  resolved:boolean,
  collapsed:boolean
  isRoot:boolean,
  isLeaf:boolean
}

// FoodVoc implementation
export class TreeRequestBody {
  constructor (public id:string, public language: string) {
  }
}

export class Point {
  constructor (public x:number, public y: number) {
  }
}  

export enum LeftPaneSelection {
  Ontologies,
  Ontology
}
export class Statement {
    subject:SparqlVariable
    predicate:SparqlVariable
    object:SparqlVariable
  
}
export class Concept {
  concept:SparqlVariable
  literals:Statement[]
  properties:Statement[]
  incomingConcepts:Statement[]
  outgoingConcepts:Statement[] 
  domains:Statement[]
  ranges:Statement[]
  superProperties:Statement[]
  subProperties:Statement[]
  instances:Statement[]
  subClasses:Statement[]
  superClasses:Statement[]
  broaders:Statement[]
  narrowers:Statement[]
  types:Statement[]
}
export class Ontology{
  public skos:boolean
  public id:string
  public name:string
  public server:string
  public namespace:string
  public topConcepts:Concept[]

}
export class Ontologies{
  public ontologies:Ontology[];
}

export class ConceptRequest {
    public id:string 
    public lang:string
    public ontologyId:string 
}



// WEBPACK FOOTER //
// ./src/model/models.ts